import { FilterCheckbox } from 'components/core';
import { useContext } from 'react';
import { FilterContext } from 'utils/context';
import DK from 'utils/dictionaries/filter_dictionary';

import { Flex, Switch } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

function TransportModeFilter() {
  const { t } = useTranslation();
  const { filters, setFiltersKey } = useContext(FilterContext);
  const isEnabled = !!filters[DK.MODE_OF_SHIPMENT_SCOPES];

  const handleToggle = (isSelected?: boolean) => {
    if (isSelected) {
      setFiltersKey(DK.MODE_OF_SHIPMENT_SCOPES, ['CURRENT']);
    } else {
      setFiltersKey(DK.MODE_OF_SHIPMENT_SCOPES, '');
    }
  };

  return (
    <Flex
      data-testid="transport-mode-filter"
      gap="medium"
      orientation="vertical"
    >
      <FilterCheckbox
        id={DK.MODE_OF_SHIPMENT}
        options={[DK.OCEAN, DK.AIR, DK.RAIL, DK.TRUCKLOAD, DK.LTL, DK.PARCEL]}
      />
      <Switch
        aria-label={t('core.transportModeLabel')}
        onChange={handleToggle}
        isSelected={isEnabled}
        children={t('core.transportModeLabel')}
      />
    </Flex>
  );
}

export default TransportModeFilter;
